import React from 'react';

import getStaticUrl from 'Jsx/Utils/getStaticUrl';

const CardLogos = () => (
  <img
    src={getStaticUrl('img/checkout/cardlogos.png')}
    alt="cards"
    width="124px"
    height="16px"
  />
);

export default CardLogos;
